import { type NotifyOrderDelayInput, notifyOrderDelayInputSchema } from '@repo/api-contracts';
import { useId, useState } from 'react';
import { formStyles, Input, Label, OrderActionDialog } from '@/shared/ui';

interface OrderDelayDialogProps {
  readonly orderId: string;
  readonly expectedShipDate: string | null;
  readonly today: string;
  readonly onSubmit: (input: NotifyOrderDelayInput) => Promise<unknown>;
  readonly onReload: () => void;
  readonly onClose: () => void;
  readonly pending?: boolean;
}

/** 지연 안내 — 오늘 이상이며 기존 예정일보다 뒤인 새 출고 예정일과 사유(1~500자)를 고객에게 알린다. */
export function OrderDelayDialog({
  orderId,
  expectedShipDate,
  today,
  onSubmit,
  onReload,
  onClose,
  pending,
}: OrderDelayDialogProps) {
  const id = useId();
  const [date, setDate] = useState('');
  const [reason, setReason] = useState('');
  return (
    <OrderActionDialog
      title="지연 안내"
      submitLabel="지연 안내 보내기"
      onReload={onReload}
      onClose={onClose}
      pending={pending}
      validate={() =>
        !notifyOrderDelayInputSchema.safeParse({ orderId, newDate: date, reason }).success ||
        date < today ||
        (expectedShipDate !== null && date <= expectedShipDate)
          ? '오늘 이상이며 기존 예정일보다 뒤인 날짜와 사유 1~500자를 입력해 주세요.'
          : null
      }
      onSubmit={async () => {
        await onSubmit({ orderId, newDate: date, reason: reason.trim() });
      }}
    >
      <p className={formStyles.hint}>기존 출고 예정일: {expectedShipDate ?? '미정'}</p>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-date`}>새 출고 예정일</Label>
        <Input
          id={`${id}-date`}
          type="date"
          min={today}
          value={date}
          onChange={(event) => setDate(event.target.value)}
        />
      </div>
      <div className={formStyles.field}>
        <Label htmlFor={`${id}-reason`}>사유</Label>
        <textarea
          id={`${id}-reason`}
          className={formStyles.textarea}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
      </div>
    </OrderActionDialog>
  );
}
